import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function Consultations({ consultations = [], consultationsStats = {} }) {
  const byStatus = consultationsStats.byStatus || {
    Approved: 0,
    Rejected: 0,
    Pending: 0,
    'In Process': 0,
    Booked: 0,
  };

  const getStatusStyles = (status) => {
    const baseClasses = "inline-block text-center px-2 py-2 w-24 rounded-full";
    switch (status) {
      case "Pending":
        return `${baseClasses} text-xs py-3 px-4 bg-blue-200 text-blue-800`;
      case "Approved":
        return `${baseClasses} text-xs py-3 px-4 bg-green-200 text-green-800`;
      case "Rejected":
        return `${baseClasses} text-xs py-3 px-4 bg-red-200 text-red-800`;
      case "In Process":
        return `${baseClasses} text-xs py-3 px-4 bg-yellow-200 text-yellow-800`;
      case "Booked":
        return `${baseClasses} text-xs py-3 px-4 bg-purple-200 text-purple-800`;
      default:
        return `${baseClasses} text-xs py-3 px-4 bg-gray-200 text-gray-800`;
    }
  };

  const data = {
    labels: ['Approved', 'Rejected', 'Pending', 'In Process', 'Booked'],
    datasets: [
      {
        label: '# of Consultations',
        data: [
          byStatus.Approved,
          byStatus.Rejected,
          byStatus.Pending,
          byStatus['In Process'],
          byStatus.Booked,
        ],
        backgroundColor: [
          'rgba(75, 192, 192, 0.2)',
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(153, 102, 255, 0.2)'
        ],
        borderColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(153, 102, 255, 1)'
        ],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="flex justify-between items-stretch mb-8 space-x-4 h-full">
      {/* Table Container */}
      <div className="w-[65%] bg-white rounded-lg shadow-lg flex flex-col">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-300 bg-gray-100">
              <th className="px-4 py-2 text-center text-gray-400">Consultation ID</th>
              <th className="px-4 py-2 text-center text-gray-400">Student Name</th>
              <th className="px-4 py-2 text-center text-gray-400">Consultant Name</th>
              <th className="px-4 py-2 text-center text-gray-400">Status</th>
            </tr>
          </thead>
          <tbody>
            {consultations.length > 0 ? (
              consultations.map((reviewedConsultation) => (
                <tr key={reviewedConsultation._id} className="border-b border-gray-300 text-center">
                  <td className="px-4 py-4 text-gray-700 text-sm">{reviewedConsultation.consultationId}</td>
                  <td className="px-4 py-4 text-gray-700 text-sm">
                    {reviewedConsultation.studentName || 'N/A'}
                  </td>
                  <td className="px-4 py-4 text-gray-700 text-sm">
                    {reviewedConsultation.consultantName || 'TBD'}
                  </td>
                  <td className="px-4 py-4 text-center">
                    <span className={getStatusStyles(reviewedConsultation.status)}>
                      {reviewedConsultation.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="px-4 py-4 text-gray-400 text-center">
                  No consultations found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Chart Container */}
      <div className="w-[35%] bg-white rounded-lg shadow-lg flex items-center justify-center">
        <div className='h-80'>
        <Doughnut data={data}/>
        </div>
      </div>
    </div>
  );
}

export default Consultations;